import { Getter } from "../types";

export default {
  [Getter.GET_SCHEDULES]: state => {
    return hash =>
      state.schedules.find(schedule => {
        return schedule.hash === hash;
      });
  }
};